import { Component } from '@angular/core';

import { IonicPage, NavController, NavParams,LoadingController,Slides,Events,Platform,AlertController } from 'ionic-angular';

import { Http } from '@angular/http';
import { MenuController } from 'ionic-angular';
import { Commontask } from '../../providers/commontask'
import { Webservice } from '../../providers/webservice'
import { Storagehelper } from '../../providers/storagehelper'
import { SocialSharing } from '@ionic-native/social-sharing';

/**
 * Generated class for the FavoritepagesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-favoritepages',
  templateUrl: 'favoritepages.html',
})
export class FavoritepagesPage extends Commontask {
  public textproperty;
  public favoriteTasks;
  constructor(public navCtrl: NavController, public navParams: NavParams,public menuctrl: MenuController,public http:Http,public webservice:Webservice,public loader:LoadingController,public storage:Storagehelper,public event:Events,public alertCtrl:AlertController,public platform:Platform,public socialShare:SocialSharing) {
  		super(menuctrl,event,platform,socialShare,alertCtrl);
    	this.textproperty={bck:"",title:"",menu_category:-1};
    	this.favoriteTasks=[];
    	this.getMenuTitle();
    	this.loadFavoriteItems();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FavoritepagesPage');
  }

  loadFavoriteItems(){
    this.storage.getStorageItem("favoriteTasks").then((data)=>{
      if(data!=null)
        this.favoriteTasks=data;

    	this.favoriteTasks.forEach((e,i)=>{
            if(e.PageTypeID==1){
              e.menuIcon="fa-file-text-o"; //page text
            }else if(e.PageTypeID==2){
              e.menuIcon="fa-volume-up"; //page text
            }else if(e.PageTypeID==4){
              e.menuIcon="fa-film"; //page text
            }else if(e.PageTypeID==3){
              e.menuIcon="fa-square-o"; //page text
            }
        })
    })
  }

  getMenuTitle(){
    this.storage.getStorageItem("staticTexts").then(menuTexts=>{    
             var bck=menuTexts.filter((e,i)=>{
               return e.textid==4;
             });
             if(bck.length>0){
               this.textproperty.bck=bck[0].menuBackground;
               this.textproperty.title=bck[0].staticText;
             }
             
         })
  }


 
   ionViewDidEnter(){
    // if(this.audioplayer.src!=""){
    //   this.Play();
    // }
    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewCanEnter(){

    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewWillEnter(){
    this.loadFavoriteItems();
    this.event.publish('app:changeHeaderBackground'); 
  }

}



// WEBPACK FOOTER //
// ./src/pages/favoritepages/favoritepages.ts